/** `cover` = remplir (recadrer), `contain` = contenir (ajuster). */
export const MEDIA_FIT = {
  cover: 'cover',
  contain: 'contain',
};

export const DEFAULT_MEDIA_ASPECT_RATIO = 16 / 9;

const RATIO_PRESETS = {
  auto: null,
  '16/9': 16 / 9,
  '21/9': 21 / 9,
  '4/3': 4 / 3,
  '1/1': 1,
};

export function parseMediaAspectRatioOption(value) {
  // Ratio numérique : proportions d'une box image du proposal (cf. imageFitWebProps).
  if (typeof value === 'number') return value > 0 ? value : null;
  if (!value || value === 'auto') return null;
  return RATIO_PRESETS[value] ?? null;
}

export function resolveMediaObjectFit(mediaFit) {
  return mediaFit === MEDIA_FIT.contain ? 'contain' : 'cover';
}

/** Variables CSS héritées par les enfants (conteneurs). */
export function mediaFitVars(mediaFit) {
  const objectFit = resolveMediaObjectFit(mediaFit);
  return {
    '--media-object-fit': objectFit,
    '--image-object-fit': objectFit,
  };
}

/** object-fit inline sur img / video uniquement. */
export function mediaFitInline(mediaFit) {
  return { objectFit: resolveMediaObjectFit(mediaFit) };
}

/** Style complet (vars + inline) — éviter sur AspectRatio / grilles. */
export function mediaFitStyle(mediaFit) {
  return { ...mediaFitVars(mediaFit), ...mediaFitInline(mediaFit) };
}

/** Contenir + ratio auto → hauteur pilotée par le média, pas une boîte fixe. */
export function usesIntrinsicContainLayout(mediaFit, mediaAspectRatio, { asBackground = false } = {}) {
  if (asBackground) return false;
  if (mediaFit !== MEDIA_FIT.contain) return false;
  return parseMediaAspectRatioOption(mediaAspectRatio) == null;
}

/** @deprecated Préférer {@link mediaFitVars} */
export function mediaFitCssVars(mediaFit) {
  return mediaFitVars(mediaFit);
}

export function isVideoSource(src, mediaType) {
  if (mediaType === 'video') return true;
  if (!src || typeof src !== 'string') return false;
  return /\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(src);
}
